type PilotContext = {
  activatedAt: string | null;
  sessionId: string | null;
};

type ControlledLogoutDependencies = {
  getPilotContext: () => Promise<PilotContext>;
  getStoredAccessToken: () => Promise<string | null>;
  clearAuthSession: () => Promise<void>;
  resetPrototypeSession: () => Promise<void>;
  requestPilotErasure: (accessToken: string) => Promise<void>;
};

export const createControlledLogout = ({
  getPilotContext,
  getStoredAccessToken,
  clearAuthSession,
  resetPrototypeSession,
  requestPilotErasure,
}: ControlledLogoutDependencies) => async (): Promise<void> => {
  const pilotContext = await getPilotContext().catch(() => null);
  const pilotAccessToken = pilotContext?.sessionId
    ? await getStoredAccessToken().catch(() => null)
    : null;

  await clearAuthSession();
  await resetPrototypeSession();

  if (pilotAccessToken) {
    void requestPilotErasure(pilotAccessToken).catch(() => undefined);
  }
};
